import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	CreateIntervalMessageDto,
	IntervalMessageTransactionModel,
} from '../../types'

function useMutationCreateIntervalMessage(
	props?: UseBaseMutationOptions<
		IntervalMessageTransactionModel,
		CreateIntervalMessageDto
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.CreateIntervalMessage],
		mutationFn: (data: CreateIntervalMessageDto) =>
			MessagingService.createIntervalMessage(data),
		...props,
	})
}

export default useMutationCreateIntervalMessage
